<button [class]="buttonClass()" (click)="saveListing($event)" type="button">
  <svg viewBox="0 -960 960 960" [class]="svgClass()">
    <path [attr.d]="saveSvg()" />
  </svg>
  @if (label()) {
    Save
  }
</button>
